var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pages-header"},[_c('search',{attrs:{"placeholder":"请输入仓库/客户名称"},on:{"search":_vm.handleSearch}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }